import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

/**
 * If REACT_APP_BACKEND_URL points at the same origin the SPA is served from
 * (or is empty), use a relative "/api" path. This eliminates cross-origin
 * requests entirely, avoiding CORS pre-flight and SameSite=None cookie issues
 * when the app is accessed via multiple linked domains (e.g. custom TLDs).
 */
function computeApiBase() {
    if (typeof window === "undefined") return `${BACKEND_URL}/api`;
    if (!BACKEND_URL) return "/api";
    try {
        const url = new URL(BACKEND_URL);
        if (url.origin === window.location.origin) return "/api";
    } catch {
        /* fall through */
    }
    return `${BACKEND_URL}/api`;
}

export const API = computeApiBase();

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export function formatApiError(err) {
    const d = err?.response?.data?.detail;
    if (d == null) return err?.message || "Bir hata oluştu";
    if (typeof d === "string") return d;
    if (Array.isArray(d))
        return d
            .map((e) => (typeof e?.msg === "string" ? e.msg : JSON.stringify(e)))
            .join(" ");
    if (typeof d?.msg === "string") return d.msg;
    return String(d);
}

export const CURRENCIES = [
    { code: "TRY", symbol: "₺", label: "Türk Lirası" },
    { code: "USD", symbol: "$", label: "Amerikan Doları" },
    { code: "EUR", symbol: "€", label: "Euro" },
    { code: "GBP", symbol: "£", label: "İngiliz Sterlini" },
];

export function fmt(amount, currency) {
    const c = CURRENCIES.find((x) => x.code === currency) || CURRENCIES[0];
    const n = Number(amount || 0).toLocaleString("tr-TR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    return `${c.symbol}${n}`;
}
